<template>
  <div class="voucher-management">
    <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>兑换券管理</span>
          <div style="display: flex; gap: 10px;">
            <el-button type="primary" icon="el-icon-plus" @click="generateVoucher">生成优惠券</el-button>
            <el-button type="success" icon="el-icon-send" @click="assignVoucher">发放优惠券</el-button>
          </div>
        </div>
      </template>
      <el-table :data="vouchers" style="width: 100%">
        <el-table-column prop="code" label="兑换码"></el-table-column>
        <el-table-column label="用户信息">
          <template slot-scope="scope">
            <div v-if="scope.row.user_id">
              <div>{{ scope.row.user_id.username || '用户' }}</div>
              <div style="font-size: 12px; color: #999;">ID: {{ scope.row.user_id._id }}</div>
            </div>
            <div v-else class="text-gray">未发放</div>
          </template>
        </el-table-column>
        <el-table-column prop="value" label="价值"></el-table-column>
        <el-table-column prop="total_count" label="发放数量"></el-table-column>
        <el-table-column label="剩余次数">
          <template slot-scope="scope">
            {{ (scope.row.total_count || 0) - (scope.row.used_count || 0) }}
          </template>
        </el-table-column>
        <el-table-column label="兑换商品">
          <template slot-scope="scope">
            <div v-if="scope.row.product_name">{{ scope.row.product_name }}</div>
            <div v-else class="text-gray">未指定</div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row)">
              {{ displayStatus(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="expiry_date" label="过期日期"></el-table-column>
        <el-table-column prop="created_at" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <div class="voucher-action-row">
              <el-button size="small" type="primary" @click="editVoucher(scope.row)">编辑</el-button>
              <el-button size="small" type="warning" @click="exchangeProduct(scope.row)" v-if="scope.row.status === '未使用'">兑换商品</el-button>
              <el-button
                v-if="canAdminDeleteSession"
                size="small"
                type="danger"
                @click="deleteVoucher(scope.row._id || scope.row.id)"
              >删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    
    <!-- 发放优惠券对话框 -->
    <el-dialog title="发放优惠券" :visible.sync="assignDialogVisible" width="500px">
      <el-form :model="assignForm" :rules="assignRules" ref="assignForm" label-width="100px">
        <el-form-item label="选择用户" prop="userId">
          <el-select
            v-model="assignForm.userId"
            placeholder="按姓名/手机号搜索并选择用户"
            style="width: 100%;"
            filterable
            clearable
          >
            <el-option 
              v-for="user in users" 
              :key="user.id"
              :label="user.username + ' (' + user.phone + ')'"
              :value="user.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发放数量" prop="total_count">
          <el-input v-model.number="assignForm.total_count" placeholder="例如 5"></el-input>
        </el-form-item>
        <el-form-item label="指定商品" prop="product_name">
          <el-select
            v-model="assignForm.product_name"
            placeholder="请选择商品"
            style="width: 100%;"
            filterable
            clearable
          >
            <el-option 
              v-for="product in products" 
              :key="product.id"
              :label="product.name + ' (¥' + product.price + ')'"
              :value="product.name">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAssign">确定</el-button>
      </span>
    </el-dialog>
    
    <!-- 兑换商品对话框 -->
    <el-dialog title="兑换商品" :visible.sync="exchangeDialogVisible" width="500px">
      <el-form :model="exchangeForm" :rules="exchangeRules" ref="exchangeForm" label-width="100px">
        <el-form-item label="优惠券编号">
          <span>{{ currentVoucher.code }}</span>
        </el-form-item>
        <el-form-item label="用户信息">
          <span>{{ currentVoucher.user_name || '用户' + currentVoucher.user_id }}</span>
        </el-form-item>
        <el-form-item label="选择商品" prop="product_name">
          <el-select v-model="exchangeForm.product_name" placeholder="请选择商品" style="width: 100%;">
            <el-option 
              v-for="product in products" 
              :key="product.id"
              :label="product.name + ' (¥' + product.price + ')'"
              :value="product.name">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exchangeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitExchange">确定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑兑换券对话框 -->
    <el-dialog title="编辑兑换券" :visible.sync="editDialogVisible" width="500px">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="兑换码">
          <el-input v-model="editForm.code" disabled></el-input>
        </el-form-item>
        <el-form-item label="价值">
          <el-input v-model.number="editForm.value"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="editForm.status" style="width: 100%;">
            <el-option label="未使用" value="未使用"></el-option>
            <el-option label="已使用" value="已使用"></el-option>
            <el-option label="已过期" value="已过期"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="过期日期">
          <el-date-picker v-model="editForm.expiry_date" type="date" placeholder="选择日期" style="width: 100%;"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { canAdminDelete } from '../utils/auth'

export default {
  name: 'VoucherManagement',
  data() {
    return {
      vouchers: [],
      users: [],
      products: [],
      assignDialogVisible: false,
      exchangeDialogVisible: false,
      currentVoucher: {},
      assignForm: {
        userId: '',
        total_count: 1,
        product_name: ''
      },
      exchangeForm: {
        product_name: ''
      },
      editDialogVisible: false,
      editForm: {
        code: '',
        value: 0,
        status: '',
        expiry_date: '',
        total_count: 1,
        product_name: ''
      },
      assignRules: {
        userId: [
          { required: true, message: '请选择用户', trigger: 'change' }
        ],
        total_count: [
          { required: true, message: '请输入发放数量', trigger: 'blur' }
        ],
        product_name: [
          { required: true, message: '请选择指定商品', trigger: 'change' }
        ]
      },
      exchangeRules: {
        product_name: [
          { required: true, message: '请选择商品', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    canAdminDeleteSession() {
      return canAdminDelete()
    },
    availableVouchers() {
      return this.vouchers.filter(voucher => !voucher.user_id && voucher.status === '未使用');
    }
  },
  mounted() {
    this.getVouchers();
    this.getUsers();
    this.getProducts();
  },
  methods: {
    async getVouchers() {
      try {
        const resp = await this.$api.get('/admin/vouchers');
        if (resp && resp.code === 200) {
          this.vouchers = resp.data || [];
          localStorage.setItem('dashboard_voucher_count', String(this.vouchers.length));
          return;
        }
      } catch (e) {
        // 后端未接好数据库时，使用前端示例数据，避免顶部红色报错
      }
      this.vouchers = [];
      localStorage.setItem('dashboard_voucher_count', '0');
    },
    getUsers() {
      this.$api
        .get('/admin/users')
        .then((resp) => {
          if (resp && resp.code === 200) {
            this.users = (resp.data || []).map((u) => ({
              id: u._id,
              username: u.username,
              phone: u.phone
            }))
          } else {
            this.users = []
          }
        })
        .catch(() => {
          this.users = []
        })
    },
    async getProducts() {
      // 优先从后端商品接口获取，失败时退回与「商品管理」一致的前端示例数据
      try {
        const resp = await this.$api.get('/products', { params: { page: 1, pageSize: 999 } });
        if (resp && resp.code === 200 && resp.data) {
          const list = resp.data.list || resp.data.items || resp.data;
          this.products = (list || []).map(p => ({
            id: p.id || p._id,
            name: p.name,
            price: p.price
          }));
          return;
        }
      } catch (e) {
        // 后端未接好时使用前端示例
      }

      this.products = [
        { id: '1', name: '宫保鸡丁', price: 25 },
        { id: '2', name: '鱼香肉丝', price: 22 },
        { id: '3', name: '糖醋排骨', price: 38 },
        { id: '4', name: '红烧肉', price: 35 },
        { id: '5', name: '米饭', price: 2.5 }
      ];
    },
    generateVoucher() {
      this.$message.info('请在“发放优惠券”中选择用户并填写数量，系统会自动生成兑换券。');
    },
    assignVoucher() {
      this.assignForm = {
        userId: '',
        total_count: 1,
        product_name: ''
      };
      this.assignDialogVisible = true;
    },
    submitAssign() {
      this.$refs.assignForm.validate(async (valid) => {
        if (!valid) return;
        const user = this.users.find(u => u.id === this.assignForm.userId);
        if (!user) {
          this.$message.error('用户不存在');
          return;
        }
        try {
          const product = this.products.find((p) => p.name === this.assignForm.product_name)
          const payload = {
            user_id: this.assignForm.userId,
            value: product && product.price != null ? Number(product.price) : 0,
            expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            total_count: this.assignForm.total_count,
            product_name: this.assignForm.product_name
          };
          const resp = await this.$api.post('/vouchers', payload);
          if (resp && (resp.code === 200 || resp.code === 201)) {
            this.$message.success('优惠券发放成功！');
            this.assignDialogVisible = false;
            this.getVouchers();
          } else {
            this.$message.error((resp && resp.message) || '发放优惠券失败');
          }
        } catch (e) {
          const msg =
            (e.response && e.response.data && e.response.data.message) ||
            (e.response && e.response.data && e.response.data.error) ||
            e.message ||
            '发放优惠券失败'
          this.$message.error(String(msg))
        }
      });
    },
    exchangeProduct(voucher) {
      this.currentVoucher = { ...voucher };
      this.exchangeForm = {
        product_name: ''
      };
      this.exchangeDialogVisible = true;
    },
    submitExchange() {
      this.$refs.exchangeForm.validate(async (valid) => {
        if (!valid) return;
        const product = this.products.find(p => p.name === this.exchangeForm.product_name);
        if (!product) {
          this.$message.error('商品不存在');
          return;
        }
        try {
          const id = this.currentVoucher._id || this.currentVoucher.id
          await this.$api.put(`/admin/vouchers/${id}`, { product_name: product.name })
          this.$message.success('指定兑换商品成功！');
          this.exchangeDialogVisible = false;
          this.getVouchers()
        } catch (e) {
          this.$message.error('指定兑换商品失败')
        }
      });
    },
    displayStatus(row) {
      const now = new Date();
      if (row.expiry_date && new Date(row.expiry_date) < now) {
        return '已过期';
      }
      const total = row.total_count || 1;
      const used = row.used_count || 0;
      if (used === 0) return '未使用';
      if (used < total) return '使用中';
      return '已用完';
    },
    getStatusType(row) {
      const status = this.displayStatus(row);
      switch (status) {
        case '未使用': return 'primary';
        case '使用中': return 'warning';
        case '已用完': return 'success';
        case '已过期': return 'danger';
        default: return '';
      }
    },
    editVoucher(voucher) {
      this.currentVoucher = { ...voucher };
      this.editForm = {
        code: voucher.code,
        value: voucher.value,
        status: this.displayStatus(voucher),
        expiry_date: voucher.expiry_date,
        total_count: voucher.total_count || 1,
        product_name: voucher.product_name || ''
      };
      this.editDialogVisible = true;
    },
    submitEdit() {
      const id = this.currentVoucher._id || this.currentVoucher.id
      const payload = {
        value: this.editForm.value,
        status: this.editForm.status,
        expiry_date: this.editForm.expiry_date,
        total_count: this.editForm.total_count,
        product_name: this.editForm.product_name
      }
      this.$api
        .put(`/admin/vouchers/${id}`, payload)
        .then(() => {
          this.$message.success('兑换券信息已更新');
          this.editDialogVisible = false;
          this.getVouchers()
        })
        .catch(() => {
          this.$message.error('兑换券更新失败')
        });
    },
    deleteVoucher(id) {
      this.$confirm('确定要删除该兑换券吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api
          .delete(`/admin/vouchers/${id}`)
          .then((resp) => {
            if (resp && resp.code === 202) {
              this.$message.warning((resp && resp.message) || '删除申请已提交')
            } else {
              this.$message.success((resp && resp.message) || '兑换券已删除')
            }
            this.getVouchers();
          })
          .catch((e) => {
            const msg =
              (e && e.response && e.response.data && e.response.data.message) ||
              '兑换券删除失败'
            this.$message.error(msg)
          })
      }).catch(() => {});
    }
  }
}
</script>

<style scoped>
.voucher-management {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text-gray {
  color: #999;
}

.voucher-action-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
}

.voucher-action-row .el-button {
  margin-left: 0 !important;
}
</style>